<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/workorders">Work Orders</a><span>/ {{ isEditMode() ? 'Edit' : 'Create / Single Equipment' }}</span>
</div>
<h3 #top class="m-b-12">
  {{ isEditMode() ? 'Edit Work Order-' + workorderId : 'Create Work Order' }}
</h3>
<form [formGroup]="createWorkOrderForm">
  @if (formSubmitErrors().length > 0) {
    <div class="error m-b-8">
      <mc-icon class="error-icon" icon="exclamation-octagon" size="20"></mc-icon>
      <div class="title">Errors</div>
      <ul>
        @for (error of formSubmitErrors(); track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
  <div class="flex-column">
    @if (formSubmitErrors().length === 0) {
      <app-error [formContainer]="createWorkOrderForm"></app-error>
    }
  </div>
  <!-- If Id exist then its edit mode-->
  @if (workorderId) {
    <app-edit-work-order-header
      [headerForm]="createWorkOrderForm.controls.headerForm"
      [storedExceptionReason]="workorder?.modeRestrictionExceptionReason ?? null"
      [workorderId]="workorderId"
      (headerFormValid)="headerFormValidChange($event)"
      (principalPropertyChanged)="principalPropertyChanged($event)"
      (shopChanged)="shopChanged($event)"
      (equipmentChanged)="equipmentChanged($event)"
      (modeChanged)="modeChanged($event)"></app-edit-work-order-header>
  } @else {
    <app-cwo-header
      [headerForm]="createWorkOrderForm.controls.headerForm"
      [storedExceptionReason]="workorder?.modeRestrictionExceptionReason ?? null"
      (headerFormValid)="headerFormValidChange($event)"
      (principalPropertyChanged)="principalPropertyChanged($event)"
      (shopChanged)="shopChanged($event)"
      (equipmentChanged)="equipmentChanged($event)"
      (modeChanged)="modeChanged($event)"
      (salesRestrictionOverrideChanged)="onSalesRestrictionOverrideChanged($event)"></app-cwo-header>
  }
  @if (headerFormValid()) {
    <app-cwo-container-details
      [equipment]="equipment"
      [shopLocationCode]="shop.locationCode"
      [mode]="mode.code"></app-cwo-container-details>
    <!-- Show attachments component when data is loaded -->
    @if (gettingDataFromAPIForRepairLineItemsForm()) {
      <!-- Show skeleton loader while data is loading -->
      <div class="aems-card m-b-12">
        <ngx-skeleton-loader count="3" appearance="line"></ngx-skeleton-loader>
      </div>
    } @else {
      <app-cwo-attachments
        [attachmentForm]="createWorkOrderForm.controls.attachmentForm"
        [isEditMode]="isEditMode()"
        [inspectionDetails]="getInspectionDetailsWithUpdatedGuid()"
        [shopCode]="shop.maintenanceShopCode"
        [workOrderMode]="mode.code"
        [equipmentNumber]="equipmentNumber ?? ''"
        [files]="headerAttachment"
        (inspectionImageDelete)="onInspectionImageDelete($event)">
      </app-cwo-attachments>
    }

    <!--Show Alarms components only when alarms are present and selected repair mode is non structural-->
    @if (equipment.alarms && equipment.alarms.length > 0 && mode.damageType == 1) {
      <app-cwo-alarm-details [equipment]="equipment"></app-cwo-alarm-details>
    }
    @if (gettingDataFromAPIForRepairLineItemsForm()) {
      <div class="aems-card m-b-12">
        <div class="pure-g">
          <div class="pure-u-md-8-24 p-t-12 pure-u-lg-6-24 p-b-16 p-r-8">
            <ngx-skeleton-loader [theme]="{ height: '30px' }" count="1" appearance="line" />
          </div>
          <hr />
        </div>
        <div class="pure-g">
          <div class="pure-u-md-3-24 p-t-12 pure-u-lg-2-24 p-b-16 p-r-8">
            <ngx-skeleton-loader [theme]="{ height: '30px' }" count="1" appearance="line" />
          </div>
        </div>
      </div>
    } @else if (!repairLineItemsLoadFailed()) {
      <app-cwo-line-items
        [damageAndRepairForm]="createWorkOrderForm.controls.damageAndRepairForm"
        [containerGrades]="containerGrades"
        [shop]="shop"
        [mode]="mode"
        [equipment]="equipment"
        [repairs]="repairs"
        [repairLocations]="repairLocations"
        [damages]="damages"
        [tpiCodes]="tpiCodes"
        [repairExclusions]="repairExclusions"
        [partExclusions]="partExclusions"
        [existingRepairLineItems]="this.workorder?.maintenanceOrderLines"
        [workOrderCurrency]="this.workOrderCurrency"
        [isEditMode]="isEditMode()"
        [inspectionDetails]="inspectionDetails"
        [inspectionDetailsDelete]="inspectionDetailsDelete()">
      </app-cwo-line-items>
      <app-cwo-man-hours
        [manHoursThatQualifyForPrepTime]="manHoursThatQualifyForPrepTime"
        [manHoursForm]="createWorkOrderForm.controls.manHoursForm"
        [mode]="mode"
        [totalManHoursWithoutPrepTime]="totalManhoursWithoutPrepTime"
        [isPrepTimeApplicable]="isPrepTimeApplicable"
        [existingManHours]="workorder?.maintenanceOrderManHours ?? []"></app-cwo-man-hours>
    } @else {
      <app-error [errors]="['Failed to load repair line item data, including part exclusions. Please try again.']"></app-error>
    }

    @if (cost != null) {
      <app-cwo-total-cost
        [apiCallStatus]="calculateTotalApiCallStatus"
        [totalCostForm]="createWorkOrderForm.controls.totalCostForm"
        [cost]="cost"
        [repairLineItemsAndManhourFormValid]="repairLineItemsAndManhourFormValid"></app-cwo-total-cost>
    }
    @if (cost == null && calculateTotalApiCallStatus === 'FAILED') {
      <app-error [errors]="[costCalculationErrorMessage]"></app-error>
    }
    <app-cwo-remarks
      [workOrderRemarks]="workorder?.maintenanceOrderRemarks ?? []"
      [remarkForm]="createWorkOrderForm.controls.remarkForm"
      [isNewWorkOrder]="true"></app-cwo-remarks>
    <!-- MDS buttons activate their native button on Enter and Space; handle the resulting click only once. -->
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div>
        @if (enableDraftWorkOrder()) {
          @if (!workorderId || (workorderId && workorder?.maintenanceOrderStatusCode == 10)) {
            <mc-button
              label="Save as draft"
              appearance="neutral"
              variant="outlined"
              [disabled]="
                (existingDraft.length > 0 && !isEditMode()) ||
                !headerFormValidForDraftSave() ||
                calculateTotalApiCallStatus === 'FAILED' ||
                gettingDataFromAPIForRepairLineItemsForm() ||
                repairLineItemsLoadFailed()
              "
              (click)="onSaveAsDraftClicked(top)"
              (keydown.enter)="$event.stopPropagation()"
              [loading]="saveAsDraftLoader">
            </mc-button>
          }
        }
      </div>
      <div style="display: flex">
        <mc-button
          label="Cancel"
          variant="outlined"
          appearance="primary"
          fit="medium"
          padding="default"
          class="m-r-12"
          (click)="onCancelClicked()"
          [disabled]="submitLoader">
        </mc-button>
        <mc-button
          data-cy="submit"
          variant="filled"
          appearance="primary"
          fit="medium"
          padding="default"
          [disabled]="
            createWorkOrderForm.invalid ||
            calculateTotalApiCallStatus === 'FAILED' ||
            gettingDataFromAPIForRepairLineItemsForm() ||
            repairLineItemsLoadFailed()
          "
          (click)="onSubmitClicked(top)"
          (keydown.enter)="$event.stopPropagation()"
          [loading]="submitLoader">
          {{ workorder?.maintenanceOrderStatusCode == 10 ? 'Submit' : workorderId ? 'Re-submit' : 'Submit' }}
        </mc-button>
      </div>
    </div>
  }
</form>
<mc-modal heading="Cancel Work Order" fit="small" dimension="small" [open]="openCancelConfirmation" (closed)="onCancelConfirmationClosed()">
  <p style="font-size: 0.8rem">The work order details will be deleted permanently. Are you sure you want to cancel?</p>
  <mc-button slot="secondaryAction" dialogaction="cancel" appearance="neutral" variant="outlined" (click)="onCancelRejection()"
    >Cancel</mc-button
  >
  <mc-button slot="primaryAction" appearance="primary" (click)="onCancelConfirmation()">Yes</mc-button>
</mc-modal>
